package link.erpango.quip.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.DropdownMenuItem
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.ExposedDropdownMenuBox
import androidx.compose.material.ExposedDropdownMenuDefaults
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.SnackbarHost
import androidx.compose.material.SnackbarHostState
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material.rememberScaffoldState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Done
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Share
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import link.erpango.quip.domain.entities.DCompatibleVehicle
import link.erpango.quip.domain.entities.DSparePartCatalog
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.entities.DVehicleBrand
import link.erpango.quip.domain.entities.DVehicleModel
import link.erpango.quip.features.myspareparts.MySparePartEditUiState
import link.erpango.quip.features.myspareparts.MySparePartEditViewModel
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.features.noteimport.NoteImportSelection
import link.erpango.quip.features.noteimport.NoteImportViewModel
import link.erpango.quip.ui.noteimport.NoteImportDialog
import link.erpango.quip.ui.noteimport.NoteImportEntryCard
import link.erpango.quip.ui.noteimport.NoteImportReviewBanner
import link.erpango.quip.ui.noteimport.SuggestionMarker
import link.erpango.quip.ui.noteimport.rememberFormSuggestions
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.theme.QuipDimens
import link.erpango.quip.ui.components.QuipDialogGeneric
import link.erpango.quip.ui.components.QuipDropdownTextField
import link.erpango.quip.ui.components.QuipSectionHeader
import link.erpango.quip.ui.components.QuipTextButton
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.ui.components.QuipTransparentHeader
import org.jetbrains.compose.resources.stringResource
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.additional_info_label
import quip.composeapp.generated.resources.brand
import quip.composeapp.generated.resources.cancel
import quip.composeapp.generated.resources.category_header
import quip.composeapp.generated.resources.delete
import quip.composeapp.generated.resources.durability_days_label
import quip.composeapp.generated.resources.model
import quip.composeapp.generated.resources.my_spare_part_add_brand_only
import quip.composeapp.generated.resources.my_spare_part_compatible_vehicles_header
import quip.composeapp.generated.resources.my_spare_part_delete_message
import quip.composeapp.generated.resources.my_spare_part_delete_title
import quip.composeapp.generated.resources.my_spare_part_deleted_successfully
import quip.composeapp.generated.resources.my_spare_part_edit_title_create
import quip.composeapp.generated.resources.my_spare_part_edit_title_edit
import quip.composeapp.generated.resources.my_spare_part_garage_empty
import quip.composeapp.generated.resources.my_spare_part_garage_vehicles_header
import quip.composeapp.generated.resources.my_spare_part_invalid_durability
import quip.composeapp.generated.resources.my_spare_part_saved_successfully
import quip.composeapp.generated.resources.my_spare_part_unknown
import quip.composeapp.generated.resources.my_spare_parts_error_generic
import quip.composeapp.generated.resources.please_complete_all_required_fields
import quip.composeapp.generated.resources.reference_optional_label
import quip.composeapp.generated.resources.required
import quip.composeapp.generated.resources.save
import quip.composeapp.generated.resources.share
import quip.composeapp.generated.resources.spare_part_type_label

/**
 * Pantalla para crear y editar un repuesto personal ("Mis repuestos").
 *
 * Incluye las dos relaciones opcionales: vehículos compatibles (marca + modelo del
 * catálogo) y vehículos del garaje del usuario. Ambas pueden quedar vacías.
 */
@OptIn(ExperimentalMaterialApi::class)
@Composable
fun MySparePartEditScreen(
    state: MySparePartEditUiState,
    sparePartCatalog: DSparePartCatalog,
    garageVehicles: List<DVehicle>,
    onCategorySelected: (String?) -> Unit,
    onSparePartTypeSelected: (String?) -> Unit,
    onBrandChange: (String) -> Unit,
    onModelChange: (String) -> Unit,
    onReferenceChange: (String) -> Unit,
    onDurabilityDaysChange: (String) -> Unit,
    onAdditionalInfoChange: (String) -> Unit,
    onAddCompatibleVehicle: (brandId: Int, modelId: Int?) -> Unit,
    onRemoveCompatibleVehicle: (DCompatibleVehicle) -> Unit,
    onToggleGarageVehicle: (vin: String) -> Unit,
    onSaveClick: () -> Unit,
    onDeleteConfirm: () -> Unit,
    /** Acción de compartir; solo se muestra en modo edición (repuesto existente). */
    onShareClick: (() -> Unit)? = null,
    onBackClick: () -> Unit,
    /** "Rellenar desde nota": solo en modo creación; null lo oculta. */
    noteImportViewModel: NoteImportViewModel? = null,
    /** Marca un vehículo del garaje (el que la nota asocia al repuesto). */
    onSelectGarageVehicle: (vin: String) -> Unit = {}
) {
    val snackbarHostState = remember { SnackbarHostState() }

    // "Rellenar desde nota"
    val suggestions = rememberFormSuggestions<SparePartFormField>()
    var showNoteImport by remember { mutableStateOf(false) }
    var showReviewBanner by remember { mutableStateOf(false) }
    val categoryLabel = stringResource(Res.string.category_header)
    val typeLabel = stringResource(Res.string.spare_part_type_label)
    val brandLabel = stringResource(Res.string.brand)
    val modelLabel = stringResource(Res.string.model)

    fun applyNoteSelection(selection: NoteImportSelection.SparePart) {
        val draft = selection.draft
        val note = selection.note
        suggestions.clearAll()
        // The type only makes sense with its own category: never pair it with a different one.
        val categoryApplies = state.categoryId == null || state.categoryId == draft.categoryId?.value
        suggestions.apply(SparePartFormField.CATEGORY, draft.categoryId, note, state.categoryId == null, { it == state.categoryId }) {
            onCategorySelected(it)
        }
        if (categoryApplies) {
            suggestions.apply(SparePartFormField.TYPE, draft.typeId, note, state.sparePartTypeId == null, { it == state.sparePartTypeId }) {
                onSparePartTypeSelected(it)
            }
        }
        suggestions.apply(SparePartFormField.BRAND, draft.brand, note, state.brand.isBlank(), { it.equals(state.brand, ignoreCase = true) }) { onBrandChange(it) }
        suggestions.apply(SparePartFormField.MODEL, draft.model, note, state.model.isBlank(), { it.equals(state.model, ignoreCase = true) }) { onModelChange(it) }
        suggestions.apply(SparePartFormField.REFERENCE, draft.reference, note, state.reference.isBlank(), { it == state.reference }) { onReferenceChange(it) }
        selection.garageVin?.let(onSelectGarageVehicle)
        showReviewBanner = true
    }
    var showDeleteDialog by remember { mutableStateOf(false) }

    // Selección pendiente en la sección de compatibilidad (marca/modelo antes de añadir el chip).
    var pendingBrandId by remember { mutableStateOf<Int?>(null) }
    var pendingModelId by remember { mutableStateOf<Int?>(null) }
    val pendingBrand = state.vehicleBrands.find { it.id == pendingBrandId }
    val pendingModels = pendingBrand?.models ?: emptyList()
    val pendingModel = pendingModels.find { it.id == pendingModelId }

    // Tipos de repuesto filtrados por la categoría seleccionada.
    val filteredSparePartTypes = remember(state.categoryId, sparePartCatalog) {
        state.categoryId?.let { catId ->
            sparePartCatalog.sparePartTypes.values.filter { it.categoryId == catId }
        } ?: emptyList()
    }

    // Snackbar de errores: sentinels de validación o mensaje crudo del backend.
    val errorSnackbarText = state.snackbarMessage?.let { raw ->
        when (raw) {
            MySparePartEditViewModel.SNACKBAR_REQUIRED_FIELDS -> stringResource(Res.string.please_complete_all_required_fields)
            MySparePartEditViewModel.SNACKBAR_INVALID_DURABILITY -> stringResource(Res.string.my_spare_part_invalid_durability)
            MySparePartEditViewModel.SNACKBAR_GENERIC_ERROR -> stringResource(Res.string.my_spare_parts_error_generic)
            else -> raw
        }
    }

    LaunchedEffect(state.snackbarMessage) {
        errorSnackbarText?.let { snackbarHostState.showSnackbar(it) }
    }

    // Snackbar de éxito; App.kt navega de vuelta a continuación.
    val successSnackbarText = if (state.saved || state.deleted) {
        stringResource(if (state.saved) Res.string.my_spare_part_saved_successfully else Res.string.my_spare_part_deleted_successfully)
    } else null

    LaunchedEffect(state.saved, state.deleted) {
        successSnackbarText?.let { snackbarHostState.showSnackbar(it) }
    }

    val title = if (state.partId != null) {
        stringResource(Res.string.my_spare_part_edit_title_edit)
    } else {
        stringResource(Res.string.my_spare_part_edit_title_create)
    }

    Scaffold(
        scaffoldState = rememberScaffoldState(snackbarHostState = snackbarHostState),
        floatingActionButton = {
            FloatingActionButton(
                onClick = onSaveClick,
                backgroundColor = QuipColors.colorPrimary,
                contentColor = Color.White
            ) {
                Icon(Icons.Default.Done, contentDescription = stringResource(Res.string.save))
            }
        },
        snackbarHost = { SnackbarHost(snackbarHostState) },
        backgroundColor = QuipColors.colorBackground
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .imePadding()
        ) {
            QuipTransparentHeader {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    IconButton(onClick = onBackClick) {
                        Icon(
                            Icons.Default.ArrowBack,
                            contentDescription = title,
                            tint = QuipColors.colorText
                        )
                    }
                    Spacer(modifier = Modifier.width(QuipDimens.padding8))
                    Text(
                        text = title,
                        style = MaterialTheme.typography.h5,
                        fontWeight = FontWeight.Bold,
                        color = QuipColors.colorText
                    )
                    if (state.partId != null) {
                        Spacer(modifier = Modifier.weight(1f))
                        onShareClick?.let { shareClick ->
                            IconButton(onClick = shareClick) {
                                Icon(
                                    Icons.Default.Share,
                                    contentDescription = stringResource(Res.string.share),
                                    tint = QuipColors.colorText
                                )
                            }
                        }
                        IconButton(onClick = { showDeleteDialog = true }) {
                            Icon(
                                Icons.Default.Delete,
                                contentDescription = stringResource(Res.string.delete),
                                tint = QuipColors.colorError
                            )
                        }
                    }
                }
            }

            when {
                state.isLoading -> Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    CircularProgressIndicator()
                }

                state.loadError != null -> Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = state.loadError.orEmpty().ifBlank { stringResource(Res.string.my_spare_parts_error_generic) },
                        color = QuipColors.colorError,
                        modifier = Modifier.padding(horizontal = QuipDimens.padding24)
                    )
                }

                else -> Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = QuipDimens.padding16)
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(QuipDimens.padding12)
                ) {
                    if (state.partId == null && noteImportViewModel != null) {
                        if (showReviewBanner) {
                            NoteImportReviewBanner(
                                missingFields = listOfNotNull(
                                    categoryLabel.takeIf { state.categoryId == null },
                                    typeLabel.takeIf { state.sparePartTypeId == null },
                                    brandLabel.takeIf { state.brand.isBlank() },
                                    modelLabel.takeIf { state.model.isBlank() },
                                ),
                                onDismiss = { showReviewBanner = false }
                            )
                        } else {
                            NoteImportEntryCard(onClick = {
                                noteImportViewModel.open(NoteImportTarget.SPARE_PART)
                                showNoteImport = true
                            })
                        }
                    }

                    // Categoría
                    var showCategoryMenu by remember { mutableStateOf(false) }
                    QuipSectionHeader(title = stringResource(Res.string.category_header), icon = Icons.Default.Add)
                    ExposedDropdownMenuBox(
                        expanded = showCategoryMenu,
                        onExpandedChange = { showCategoryMenu = !showCategoryMenu }
                    ) {
                        QuipTextField(
                            value = state.categoryId
                                ?.let { id -> getSparePartCategoryString(sparePartCatalog.categories[id] ?: "") }
                                ?: "",
                            onValueChange = {},
                            label = stringResource(Res.string.category_header),
                            readOnly = true,
                            trailingIcon = {
                                ExposedDropdownMenuDefaults.TrailingIcon(expanded = showCategoryMenu)
                            }
                        )
                        ExposedDropdownMenu(
                            expanded = showCategoryMenu,
                            onDismissRequest = { showCategoryMenu = false }
                        ) {
                            sparePartCatalog.categories.forEach { (id, translationKey) ->
                                DropdownMenuItem(onClick = {
                                    onCategorySelected(id)
                                    suggestions.clear(SparePartFormField.CATEGORY)
                                    suggestions.clear(SparePartFormField.TYPE)
                                    showCategoryMenu = false
                                }) {
                                    Text(getSparePartCategoryString(translationKey))
                                }
                            }
                        }
                    }
                    SuggestionMarker(suggestions[SparePartFormField.CATEGORY])

                    // Tipo de repuesto (filtrado por categoría)
                    var showTypeMenu by remember { mutableStateOf(false) }
                    QuipSectionHeader(title = stringResource(Res.string.spare_part_type_label), icon = Icons.Default.Add)
                    ExposedDropdownMenuBox(
                        expanded = showTypeMenu,
                        onExpandedChange = { if (state.categoryId != null) showTypeMenu = !showTypeMenu }
                    ) {
                        QuipTextField(
                            value = state.sparePartTypeId
                                ?.let { id -> sparePartCatalog.sparePartTypes[id]?.translationKey }
                                ?.let { key -> getSparePartTypeString(key) }
                                ?: "",
                            onValueChange = {},
                            label = stringResource(Res.string.spare_part_type_label),
                            readOnly = true,
                            enabled = state.categoryId != null,
                            trailingIcon = {
                                ExposedDropdownMenuDefaults.TrailingIcon(expanded = showTypeMenu)
                            }
                        )
                        ExposedDropdownMenu(
                            expanded = showTypeMenu,
                            onDismissRequest = { showTypeMenu = false }
                        ) {
                            filteredSparePartTypes.forEach { type ->
                                DropdownMenuItem(onClick = {
                                    onSparePartTypeSelected(type.id)
                                    suggestions.clear(SparePartFormField.TYPE)
                                    showTypeMenu = false
                                }) {
                                    Text(getSparePartTypeString(type.translationKey))
                                }
                            }
                        }
                    }
                    SuggestionMarker(suggestions[SparePartFormField.TYPE])

                    // Datos del repuesto
                    QuipTextField(
                        value = state.brand,
                        onValueChange = { onBrandChange(it); suggestions.clear(SparePartFormField.BRAND) },
                        label = stringResource(Res.string.brand),
                        helperText = {
                            Text(
                                stringResource(Res.string.required),
                                color = QuipColors.colorText.copy(alpha = 0.6f),
                                modifier = Modifier.padding(start = QuipDimens.padding16)
                            )
                        }
                    )
                    SuggestionMarker(suggestions[SparePartFormField.BRAND])
                    QuipTextField(
                        value = state.model,
                        onValueChange = { onModelChange(it); suggestions.clear(SparePartFormField.MODEL) },
                        label = stringResource(Res.string.model),
                        helperText = {
                            Text(
                                stringResource(Res.string.required),
                                color = QuipColors.colorText.copy(alpha = 0.6f),
                                modifier = Modifier.padding(start = QuipDimens.padding16)
                            )
                        }
                    )
                    SuggestionMarker(suggestions[SparePartFormField.MODEL])
                    QuipTextField(
                        value = state.reference,
                        onValueChange = { onReferenceChange(it); suggestions.clear(SparePartFormField.REFERENCE) },
                        label = stringResource(Res.string.reference_optional_label),
                        keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
                    )
                    SuggestionMarker(suggestions[SparePartFormField.REFERENCE])
                    QuipTextField(
                        value = state.durabilityDays,
                        onValueChange = onDurabilityDaysChange,
                        label = stringResource(Res.string.durability_days_label),
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
                    )
                    QuipTextField(
                        value = state.additionalInfo,
                        onValueChange = onAdditionalInfoChange,
                        label = stringResource(Res.string.additional_info_label),
                        minLines = 3
                    )

                    // Vehículos compatibles (opcional)
                    QuipSectionHeader(
                        title = stringResource(Res.string.my_spare_part_compatible_vehicles_header),
                        icon = Icons.Default.Build
                    )
                    Row(horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
                        QuipDropdownTextField<DVehicleBrand>(
                            options = state.vehicleBrands,
                            selectedOption = pendingBrand,
                            itemToStringTitle = { it.name },
                            label = stringResource(Res.string.brand),
                            modifier = Modifier.weight(1f),
                            onOptionSelected = { _, option ->
                                pendingBrandId = option.id
                                pendingModelId = null
                            },
                            onClearOption = {
                                pendingBrandId = null
                                pendingModelId = null
                            }
                        )
                        QuipDropdownTextField<DVehicleModel>(
                            options = pendingModels,
                            selectedOption = pendingModel,
                            itemToStringTitle = { it.name },
                            label = stringResource(Res.string.model),
                            modifier = Modifier.weight(1f),
                            isEnabled = pendingBrand != null && pendingModels.isNotEmpty(),
                            onOptionSelected = { _, option ->
                                pendingBrand?.let { brand ->
                                    onAddCompatibleVehicle(brand.id, option.id)
                                    pendingModelId = null
                                }
                            },
                            onClearOption = { pendingModelId = null }
                        )
                    }
                    QuipTextButton(
                        text = stringResource(Res.string.my_spare_part_add_brand_only),
                        onClick = { pendingBrand?.let { brand -> onAddCompatibleVehicle(brand.id, null) } },
                        icon = Icons.Default.Add,
                        enabled = pendingBrand != null
                    )
                    if (state.selectedCompatibleVehicles.isNotEmpty()) {
                        FlowRow(
                            horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding6),
                            verticalArrangement = Arrangement.spacedBy(QuipDimens.padding4)
                        ) {
                            state.selectedCompatibleVehicles.forEach { compatible ->
                                RemovableChip(
                                    text = compatibleVehicleLabel(compatible, state.vehicleBrands),
                                    onRemove = { onRemoveCompatibleVehicle(compatible) }
                                )
                            }
                        }
                    }

                    // Vehículos del garaje (opcional)
                    QuipSectionHeader(
                        title = stringResource(Res.string.my_spare_part_garage_vehicles_header),
                        icon = Icons.Default.Home
                    )
                    if (garageVehicles.isEmpty()) {
                        Text(
                            text = stringResource(Res.string.my_spare_part_garage_empty),
                            style = MaterialTheme.typography.body2,
                            color = QuipColors.colorTextSecondary
                        )
                    } else {
                        FlowRow(
                            horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding6),
                            verticalArrangement = Arrangement.spacedBy(QuipDimens.padding4)
                        ) {
                            garageVehicles.forEach { vehicle ->
                                GarageVehicleChip(
                                    label = "${vehicle.plate} · ${vehicle.brand} ${vehicle.model}",
                                    selected = vehicle.vin in state.selectedGarageVins,
                                    onClick = { onToggleGarageVehicle(vehicle.vin) }
                                )
                            }
                        }
                    }

                    Spacer(modifier = Modifier.height(QuipDimens.padding24))
                }
            }
        }
    }

    if (showNoteImport && noteImportViewModel != null) {
        NoteImportDialog(
            viewModel = noteImportViewModel,
            sparePartCatalog = sparePartCatalog,
            onDismiss = {
                showNoteImport = false
                noteImportViewModel.reset()
            },
            onApply = { selection ->
                if (selection is NoteImportSelection.SparePart) applyNoteSelection(selection)
                showNoteImport = false
                noteImportViewModel.reset()
            }
        )
    }

    if (showDeleteDialog) {
        QuipDialogGeneric(
            title = stringResource(Res.string.my_spare_part_delete_title),
            message = stringResource(Res.string.my_spare_part_delete_message),
            confirmButtonText = stringResource(Res.string.delete),
            dismissButtonText = stringResource(Res.string.cancel),
            onConfirm = {
                showDeleteDialog = false
                onDeleteConfirm()
            },
            onDismiss = { showDeleteDialog = false },
            isConfirmColored = true,
            accentColor = QuipColors.colorError
        )
    }
}

/** Etiqueta de un vehículo compatible: "Marca Modelo" o solo la marca. */
@Composable
private fun compatibleVehicleLabel(vehicle: DCompatibleVehicle, brands: List<DVehicleBrand>): String {
    val brand = brands.find { it.id == vehicle.brandId }
    val brandName = brand?.name ?: stringResource(Res.string.my_spare_part_unknown)
    val modelName = vehicle.modelId?.let { modelId ->
        brand?.models?.find { it.id == modelId }?.name
    }
    return if (modelName != null) "$brandName $modelName" else brandName
}

/** Chip con texto y botón de quitar, para los vehículos compatibles seleccionados. */
@Composable
private fun RemovableChip(text: String, onRemove: () -> Unit) {
    Surface(
        shape = RoundedCornerShape(QuipDimens.cornerRadius8),
        color = QuipColors.colorPrimary.copy(alpha = 0.15f)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = QuipDimens.padding8, vertical = QuipDimens.padding4),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = text,
                style = MaterialTheme.typography.caption,
                fontWeight = FontWeight.Bold,
                color = QuipColors.colorPrimary
            )
            IconButton(onClick = onRemove, modifier = Modifier.size(QuipDimens.iconSize20)) {
                Icon(
                    Icons.Default.Close,
                    contentDescription = null,
                    tint = QuipColors.colorPrimary,
                    modifier = Modifier.size(QuipDimens.iconSize16)
                )
            }
        }
    }
}

/** Chip seleccionable (multi-selección) para los vehículos del garaje. */
@Composable
private fun GarageVehicleChip(label: String, selected: Boolean, onClick: () -> Unit) {
    Surface(
        shape = RoundedCornerShape(QuipDimens.cornerRadius8),
        color = if (selected) QuipColors.colorPrimary else QuipColors.colorPrimary.copy(alpha = 0.15f),
        modifier = Modifier.clickable(onClick = onClick)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = QuipDimens.padding8, vertical = QuipDimens.padding6),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = label,
                style = MaterialTheme.typography.caption,
                fontWeight = FontWeight.Bold,
                color = if (selected) Color.White else QuipColors.colorPrimary
            )
        }
    }
}

/** Fields of the spare part form that can be filled from a note. */
private enum class SparePartFormField { CATEGORY, TYPE, BRAND, MODEL, REFERENCE }
